import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import { organizationUnits } from '../../../../../../redux/organizationUnits/action';
import StoreComponent from '../components/store.component';
import { deepCopy } from '../../../../../../common/services/common.service';
import { stores } from '../../../../../../redux/stores/action';
import { selectStoresQueryItems } from '../../../../../../redux/stores/selector';
let currentChange: any = {}

const ManagementStore = () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [
    storeBanner,
    setStoreBanner
  ] = useState<any>([])
  const parmas: any = useParams()
  const StoresQuery = useSelector(selectStoresQueryItems)
const [isQuery, setIsQuery] = useState<boolean>(false)
const [isLoading, setIsLoading] = useState<boolean>(true)
const [
    selectedAddress,
    setSelectedAddress
  ] = useState<any>({
    PrimaryAddress: {},
    BillingAddress: {},
    ShippingAddress: {}

  })  
  const [
    openFile,
    setOpenFile
  ] = useState<any>([]);
  const [
    pickupPoints,
    setPickupPoints
  ] = useState<any>([])
  const [
    selectedStore,
    setSelectedStore
  ] = useState<any>({
    IsUsePrimaryAddressAsBillingAddress: false,
    IsUsePrimaryAddressAsShippingAddress: false,
    StoreInfo: {
      CountryCode: 'INR',
      Configurations: {
        StoreBranding: {
          Primary: {},
          Secondary: {},
          Tertiary: {},
          Ghost: {}
        },
        StoreBanners: [],
        StoreLogo: {}
      }
    },
    PrimaryAddress: {},
    BillingAddress: {},
    ShippingAddress: {}
  })
  const [
    openBannerFile,
    setOpenBannerFile
  ] = useState<any>([]);
  const fetchStoresQueryById= ()=>{
    dispatch(stores.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/stores/query`,entity:'stores',jsonData:{
          
    Records: [
      {
        Id: parmas?.id
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }

  const handleInnerbasicFormChange: any = (event: any, field: string) => {
    setSelectedStore({ ...selectedStore, [field]: event })
  }
  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedStore({ ...selectedStore, [fields[0]]: value });
    setSelectedAddress({ ...selectedAddress, [fields[0]]: value });
  }
  
  useEffect(
    () => {
        dispatch(organizationUnits.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organization-units/list`,entity:'organizationUnits',jsonData:{}
           })).then(()=>{
            if (parmas?.id > 0) {
                fetchStoresQueryById()
                setIsLoading(false)
                } else{
                    setIsLoading(false) 
                }
          })
       
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedStore(StoresQuery?.result?.items)
        setSelectedAddress({ 
            PrimaryAddress: StoresQuery?.result?.items?.PrimaryAddress,
            BillingAddress: StoresQuery?.result?.items?.BillingAddress,
            ShippingAddress: StoresQuery?.result?.items?.ShippingAddress})
            setPickupPoints({StorePickupPoints: StoresQuery?.result?.items?.StorePickupPoints[0]})
            const currentSelectedChannelBanner = addNewChannelBannerRow({ selectedChannelBannerArg: StoresQuery?.result?.items?.StoreInfo?.Configurations?.StoreBanners });
    setStoreBanner(currentSelectedChannelBanner)
    }
    },
    [isQuery]
  ) 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    const storeData= {
      StoreInfo:selectedStore?.StoreInfo,
      StorePickupPoints: selectedStore?.StorePickupPoints,
           PrimaryAddress:selectedAddress?.PrimaryAddress,
        IsUsePrimaryAddressAsBillingAddress: selectedStore?.IsUsePrimaryAddressAsBillingAddress|| false,
        BillingAddress: selectedAddress?.BillingAddress,
        IsUsePrimaryAddressAsShippingAddress: selectedStore?.IsUsePrimaryAddressAsShippingAddress || false,
        ShippingAddress: selectedAddress?.ShippingAddress
      }
      if (parmas?.id > 0) {
     dispatch(stores.update({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/stores`,entity:'stores',jsonData:{
          
    Records: [
      storeData
    ]
 
}})) .then(()=>{
    back()
  })
      }else{
        dispatch(stores.create({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/stores`,entity:'stores',jsonData:{
            
        Records: [
          storeData
        ]
      
    }})).then(()=>{
        back()
      })
      }
  }
  const changeBannerImage = (idx: number, templateField: any, fileType: any) => {
    setOpenBannerFile({
      currentFileSrc: storeBanner[idx][templateField],
      folder: 'Store',
      type: fileType
    })
    currentChange = { idx, templateField }
  }
  const handleChannelBannerItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(storeBanner);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setStoreBanner(items);
  }
  const addNewChannelBannerRow = ({ selectedChannelBannerArg }: any) => {
    const currentSelectedChannelBanner = deepCopy(selectedChannelBannerArg)
    const newSelectedChannelBannerRecord = {
      BannerImage: '',
      BannerMessage: '',
      BannerLabel: '',
      BannerLabelUrl: ''
    }
    if (currentSelectedChannelBanner.length === 0 ||
      currentSelectedChannelBanner[currentSelectedChannelBanner?.length - 1]?.BannerImage !== '' ||
      currentSelectedChannelBanner[currentSelectedChannelBanner?.length - 1]?.BannerMessage !== ''
    ) {
      currentSelectedChannelBanner?.push(newSelectedChannelBannerRecord)
    }
    return currentSelectedChannelBanner
  }
  useEffect(
    () => {
      if (currentChange.field === 'BannerImage' || currentChange.field === 'BannerMessage') {
        setCombinationInfo1()
      }
    },
    [storeBanner]
  )
  const setCombinationInfo1 = async () => {
    let localSelectedChannelBanner = deepCopy(storeBanner)
    localSelectedChannelBanner.splice(
      currentChange.idx,
      1,
      { ...localSelectedChannelBanner[currentChange.idx] }
    );
    localSelectedChannelBanner = addNewChannelBannerRow({ selectedChannelBannerArg: localSelectedChannelBanner });
    currentChange.field = 'BannerImageDONE'
    setStoreBanner(localSelectedChannelBanner)
  }
  const changeImage = (fileType: any) => {
    setOpenFile({
      currentFileSrc: selectedStore?.StoreInfo?.Configurations?.StoreLogo,
      folder: 'Store',
      type: fileType
    })
  }
const back=()=>{
  navigate('/management/organization/organization-management/stores')
} 

    return (
        <>

        {isLoading ? <PageLoader /> : 
          <StoreComponent 
          back={back}
          storeBanner={storeBanner}
          selectedStore={selectedStore} 
          pickupPoints={pickupPoints}
          handleChannelBannerItemChange={handleChannelBannerItemChange}
          changeImage={changeImage}
          changeBannerImage={changeBannerImage}
          handleInnerbasicFormChange={handleInnerbasicFormChange}
          handleFormSubmit ={handleFormSubmit}
          onInnerFormChange={handleInnerFormChange}
          selectedAddress={selectedAddress}
          /> 
    } 
          </>
    )
    
    }
   
    export default ManagementStore;